import { groupModeOptions, GroupMode } from '../types/categorical-bar-chart.js';

/**
 * Returns true if groupMode is a valid GroupMode
 * @param groupMode - group mode
 */
export const isValidGroupMode = (
  groupMode: 'grouped' | 'stacked',
): groupMode is GroupMode => groupModeOptions.includes(groupMode);
